import {reqbase} from "@/utils/request";
import { Toast } from "vant";

const user = {
  state: {
    userInfo: {}
  },
  mutations: {
    SET_USER_INFO: (state, userInfo) => {
      state.userInfo = userInfo;
    }
  },
  actions: {
    getUserInfo({ commit }) {
      return reqbase('').get("/api/user/get").then(res => {
        if (res.errorCode === 0) {
          commit("SET_USER_INFO", res.data);
        } else {
          res.msg && Toast(res.msg);
        }
      });
    }
  }
};

export default user;
